import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SpoolDto } from '../../../../types/spool-local';
import spoolsContext from '../../../../context/spools/spoolsContext';
import RiskDisclaimer from '../../../../components/RiskDisclaimer';
import {
    EmptyDataRow,
    Pagination,
    Table,
    TableRowContainer,
} from '../../../../components/Table';
import AvailableSpoolHeaders from './AvailableSpoolsHeader';
import Loading from '../../../../components/Loading';
import useAvailableSpools from '../../../../hooks/web3/app/useAvailableSpools';
import Spools from '../../../../components/Spools';
import { useWeb3React } from '@web3-react/core';
import { SupportedChains } from '../../../../config/constants';

type AvailableSpoolsParams = {
    spoolAddress: string | undefined;
};

//created by mistake, requested by Tadhg to hide
const HIDDEN_SPOOL = '0x1665b54eb5d1c95cc3e9e257a6348a8842269810';

const AvailableSpools: React.FC = () => {
    const { activeSort, searchTerm, activeFilter, filterData, sort, setSearchTerm } =
        useContext(spoolsContext);

    const { availableSpools, isLoading } = useAvailableSpools();

    const [selectedAccordion, setSelectedAccordion] = useState<string | null>(null);
    const [filteredData, setFilteredData] = useState<SpoolDto[]>([]);

    const { spoolAddress } = useParams<AvailableSpoolsParams>();

    const { chainId } = useWeb3React();

    const toggle = (spoolAddress: string) => {
        setSelectedAccordion((prev) => (prev === spoolAddress ? null : spoolAddress));
    };

    useEffect(() => {
        if (!availableSpools) return;

        const filtered = availableSpools.filter((data) =>
            filterData(data, activeFilter, searchTerm)
        );

        setFilteredData(filtered);
    }, [activeFilter, searchTerm, availableSpools, filterData]);

    useEffect(() => {
        if (spoolAddress) {
            setSearchTerm(spoolAddress);
            setSelectedAccordion(spoolAddress);
        }
    }, [spoolAddress, setSearchTerm]);

    return (
        <>
            <div className='inner__left'>
                <h2>Available Spools</h2>
                <span>
                    <span className='mobile'>Tap</span>
                    <span>Click</span> a Spool to Expand
                </span>
            </div>
            <div className='inner__right'>
                <Table
                    headers={
                        <AvailableSpoolHeaders
                            hasFilteredResults={!!filteredData.length}
                        />
                    }
                    numOfColumns={6}
                    dataLength={filteredData?.length || 0}
                    className='spools-table'
                >
                    <Loading isLoading={isLoading} text='Loading Spools...'>
                        <TableRowContainer>
                            {availableSpools ? (
                                filteredData.length ? (
                                    filteredData
                                        .sort((a, b) => sort(a, b, activeSort))
                                        .map((spoolDetails, index) => {
                                            if (
                                                chainId ===
                                                    SupportedChains.ARBITRUM_ONE &&
                                                spoolDetails.address === HIDDEN_SPOOL
                                            ) {
                                                return null;
                                            }
                                            return (
                                                <Spools
                                                    key={index}
                                                    spoolDetails={spoolDetails}
                                                    collapsed={
                                                        selectedAccordion ===
                                                        spoolDetails.address
                                                    }
                                                    toggle={toggle}
                                                />
                                            );
                                        })
                                ) : (
                                    <EmptyDataRow text='No Spools or Risk Models match your search criteria, please try again.' />
                                )
                            ) : (
                                <EmptyDataRow text='An unexpected error occurred while loading Spools.' />
                            )}
                        </TableRowContainer>
                    </Loading>
                    <Pagination rowPerPage={10} />
                </Table>
                <RiskDisclaimer updateHeightOnToggle={true} />
            </div>
        </>
    );
};

export default AvailableSpools;
